export var EntitlementExceptionsActionKind;
(function (EntitlementExceptionsActionKind) {
    EntitlementExceptionsActionKind["ModifyEntitlementExceptions"] = "ModifyEntitlementExceptions";
})(EntitlementExceptionsActionKind || (EntitlementExceptionsActionKind = {}));
